import React from 'react';
import { motion } from 'framer-motion';
import { LayoutGrid, Kanban, Calendar } from 'lucide-react';
import { ViewType } from './types';
interface ViewSwitcherProps {
  currentView: ViewType;
  onViewChange: (view: ViewType) => void;
}
export function ViewSwitcher({
  currentView,
  onViewChange
}: ViewSwitcherProps) {
  const options: {
    id: ViewType;
    label: string;
    icon: React.ElementType;
  }[] = [{
    id: 'cards',
    label: 'Cards',
    icon: LayoutGrid
  }, {
    id: 'kanban',
    label: 'Kanban',
    icon: Kanban
  }, {
    id: 'timeline',
    label: 'Timeline',
    icon: Calendar
  }];
  return <div className="bg-gray-100/80 backdrop-blur-sm p-1 rounded-lg inline-flex relative shadow-inner" data-id="element-207">
      {options.map(option => {
      const isActive = currentView === option.id;
      return <button key={option.id} onClick={() => onViewChange(option.id)} className={`
              relative z-10 px-4 py-1.5 text-sm font-medium transition-colors duration-200 flex items-center gap-2
              ${isActive ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'}
            `} data-id="element-208">
            <option.icon className="w-4 h-4" data-id="element-209" />
            <span className="hidden sm:inline" data-id="element-210">{option.label}</span>
            {isActive && <motion.div layoutId="activeViewIndicator" className="absolute inset-0 bg-white rounded-md shadow-sm border border-gray-200/50 -z-10" transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} data-id="element-211" />}
          </button>;
    })}
    </div>;
}